// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#characterSet-holder {
  position: fixed;
  margin: 0;
  padding: 0;
  z-index: 9999999;
  font-size: 3rem;
  max-width: 100%;
  text-align: center;
  user-select: none !important;
}

#characterSet-holder .characterSet {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 7px;
  box-sizing: border-box;
  border: 2px solid rgba(0, 0, 0, 0);
}

#characterSet-holder .characterSet:hover {
  border-color: black;
  cursor: pointer;
}

/* -------------------------------------------------------------------------- */

/* .readingAnswer {
  font-size: 2rem !important;
} */
`, "",{"version":3,"sources":["webpack://./components/css/showCharacterSet.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;;GAEG","sourcesContent":["#characterSet-holder {\n  position: fixed;\n  margin: 0;\n  padding: 0;\n  z-index: 9999999;\n  font-size: 3rem;\n  max-width: 100%;\n  text-align: center;\n  user-select: none !important;\n}\n\n#characterSet-holder .characterSet {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  border-radius: 7px;\n  box-sizing: border-box;\n  border: 2px solid rgba(0, 0, 0, 0);\n}\n\n#characterSet-holder .characterSet:hover {\n  border-color: black;\n  cursor: pointer;\n}\n\n/* -------------------------------------------------------------------------- */\n\n/* .readingAnswer {\n  font-size: 2rem !important;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
